import { UtilitiesIcon } from '../icons'

export default {
  id: 'utilities',
  title: {
    en: 'Water Utilities',
    ar: 'مرافق المياه'
  },
  Icon: UtilitiesIcon,
  description: {
    en: `<p>Due to Jordan’s limited water supply, it is essential that the country distributes its water resources efficiently.</p><p>Companies such as Miyahuna and the Yarmouk Water Company have been established to make sure all Jordanians have water when they open the tap at home.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'u1',
      position: { x: 473.0, y: 289.0 },
      title: { en: 'Yarmouk Water Company', ar: 'مياه اليرموك' },
      governate: { en: 'Irbid', ar: 'اربد' },
      year: '2010'
    },
    {
      id: 'u2',
      position: { x: 397.0, y: 354.0 },
      title: { en: 'Yarmouk Water Company', ar: 'مياه اليرموك' },
      governate: { en: 'Ajloun', ar: 'عجلون' },
      year: '2010'
    },
    {
      id: 'u3',
      position: { x: 516.0, y: 334.0 },
      title: { en: 'Yarmouk Water Company', ar: 'مياه اليرموك' },
      governate: { en: 'Jarash', ar: 'جرش' },
      year: '2010'
    },
    {
      id: 'u4',
      position: { x: 558.0, y: 304.0 },
      title: { en: 'Yarmouk Water Company', ar: 'مياه اليرموك' },
      governate: { en: 'Mafraq', ar: 'المفرق' },
      year: '2010'
    },
    {
      id: 'u5',
      position: { x: 421.0, y: 459.0 },
      title: { en: 'Balqa', ar: 'البلقاء' },
      governate: { en: 'Balqa', ar: 'البلقاء' },
      year: '1983 - 1988'
    },
    {
      id: 'u6',
      position: { x: 585.0, y: 449.0 },
      title: { en: 'Miyahuna', ar: 'مياهنا' },
      governate: { en: 'Zarqa', ar: 'الزرقاء' },
      year: '1983 - 1988'
    },
    {
      id: 'u7',
      position: { x: 510.0, y: 508.0 },
      title: { en: 'Miyahuna', ar: 'مياهنا' },
      governate: { en: 'Amman', ar: 'عمان' },
      year: '2007'
    },
    {
      id: 'u8',
      position: { x: 407.0, y: 594.0 },
      title: { en: 'Miyahuna', ar: 'مياهنا' },
      governate: { en: 'Madaba', ar: 'مادبا' },
      year: '2019'
    },
    {
      id: 'u9',
      position: { x: 399.0, y: 793.0 },
      title: { en: 'Karak', ar: 'الكرك' },
      governate: { en: 'Karak', ar: 'الكرك' },
      year: '1983 - 1988'
    },
    {
      id: 'u10',
      position: { x: 341.0, y: 977.0 },
      title: { en: 'Tafila', ar: 'الطفيلة' },
      governate: { en: 'Tafila', ar: 'الطفيلة' },
      year: '1983 - 1988'
    },
    {
      id: 'u11',
      position: { x: 400.0, y: 1192.0 },
      title: { en: 'Ma’an', ar: 'معان' },
      governate: { en: 'Irbid', ar: 'اربد' },
      year: '1983 - 1988'
    },
    {
      id: 'u12',
      position: { x: 167.0, y: 1391.0 },
      title: { en: 'Aqaba Water Company', ar: 'مياه العقبة' },
      governate: { en: 'Aqaba', ar: 'العقبة' },
      year: '2004'
    }
  ]
}
